export default "__VITE_ASSET__BBAY9xI2__"